import { render, staticRenderFns } from "./_preview.vue?vue&type=template&id=38fbb75c&scoped=true&"
import script from "./_preview.vue?vue&type=script&lang=js&"
export * from "./_preview.vue?vue&type=script&lang=js&"
import style0 from "./_preview.vue?vue&type=style&index=0&id=38fbb75c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fbb75c",
  null
  
)

export default component.exports